import "@styles/global.scss";
import colors from "@styles/synchrony-core-palette.js";

import { useEffect, useState, useMemo, Suspense } from "react";

import { ROUTES } from "@constants/routes";
import BaseRenderTemplate from "@/app/page-template";
import LoggedOutAllView from "@components/ui/LoggedOutAllView";
import SuspenseFallback from "@components/layout/SuspenseFallback";
import {
  featurePermissions,
  getMainPagesRoutes,
} from "@utils/navigation-helpers";
import { getBrowserParams } from "@utils/browser-helpers";

// Deprecated routes that should redirect to home
const DEPRECATED_ROUTES = ["app-feedback", "c3-users"];

const TemplateRoute = () => {
  const [context, setContext] = useState<any | null>(null);
  const [CustomComponent, setCustomComponent] = useState<any | null>(null);
  const rawPageName = location.pathname.split("/")[1] || "home";
  const pageName = rawPageName !== "" ? rawPageName : "home";

  // Redirect deprecated routes to home
  useEffect(() => {
    if (DEPRECATED_ROUTES.includes(pageName)) {
      window.location.replace("/");
    }
  }, [pageName]);
  const mainPages = useMemo(() => {
    return getMainPagesRoutes(pageName, featurePermissions);
  }, []);

  useEffect(() => {
    const returnBasePageIfExists = (contextName: string) => {
      let component: any | null = null;
      if (ROUTES.hasOwnProperty(contextName)) {
        component = ROUTES[contextName as keyof typeof ROUTES];
      } else {
        const pageToRender = Object.keys(mainPages).filter((page) =>
          mainPages[page].includes(contextName)
        );

        for (const key of pageToRender) {
          if (ROUTES.hasOwnProperty(key)) {
            component = ROUTES[key as keyof typeof ROUTES];
            break;
          }
        }
      }
      return component;
    };

    const updatedContext = returnBasePageIfExists(pageName);
    const UpdatedCustomComponent =
      updatedContext && updatedContext.hasOwnProperty("customComponent")
        ? updatedContext.customComponent
        : null;
    setContext(updatedContext);
    setCustomComponent(() => UpdatedCustomComponent);
  }, [pageName]);

  return context ? (
    <Suspense fallback={<SuspenseFallback />}>
      {CustomComponent ? (
        <CustomComponent />
      ) : (
        <BaseRenderTemplate
          {...context.options}
          pageName={context.rootName}
          allViewComponent={context.allViewComponent}
          newViewComponent={context.newViewComponent}
          mainContentWrapperStyle={context.mainContentWrapperStyle}
        />
      )}
    </Suspense>
  ) : (
    <LoggedOutAllView searchParams={getBrowserParams(location.search)} />
  );
};

export default TemplateRoute;
